import PropTypes from 'prop-types';
import React from 'react';
import {map} from 'lodash';
import HtmlCard from '../card/html_card';
//import { propTypes as rowPropTypes } from './row';

const HtmlRow = ({ cards }) => map(cards, card =>
  <HtmlCard content={card.content} cardID={card.id} key={card.id} />
);

// HtmlRow.propTypes = Object.assign({ ...rowPropTypes }, {
//   dataAttributes: PropTypes.object
// });

export default HtmlRow;
